import type { Ring, Vec2 } from '../../../../geo/types';
import type { Frame, MeshBuilder, VertexStyle } from '../../../mesh/meshBuilder';
import { prismSolid, pyramidOverRing } from '../../solids';

/** A stone pinnacle: a square shaft of half-width `half` from y0 to shaftTop under a pyramid to tipY. */
export interface PinnacleSpec {
  readonly center: Vec2;
  readonly half: number;
  readonly y0: number;
  readonly shaftTop: number;
  readonly tipY: number;
}

export function squareRing(center: Vec2, half: number): Ring {
  return [
    [center[0] - half, center[1] - half],
    [center[0] + half, center[1] - half],
    [center[0] + half, center[1] + half],
    [center[0] - half, center[1] + half],
  ];
}

export function pinnacleSolid(builder: MeshBuilder, style: VertexStyle, frame: Frame, spec: PinnacleSpec): void {
  const ring = squareRing(spec.center, spec.half);
  prismSolid(builder, style, frame, ring, spec.y0, spec.shaftTop, { top: false, bottom: false });
  pyramidOverRing(builder, { roof: style, wall: style }, frame, ring, spec.shaftTop, { plan: spec.center, y: spec.tipY });
}
